import React from 'react';
import PropTypes from 'prop-types';
import {t} from '../../Translations';
import ChoiceRow from './ChoiceRow';
import LabelButton from "../widgets/LabelButton";
import Carrousel from "../widgets/Carrousel";
import LabelButtonLabel from "../widgets/LabelButtonLabel";
import Configuration from "../../Configuration";


/**
 * Contains all choices component for step 1
 *
 * @param {*} param0
 */

class Step1Choices extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            "isCarosselActivated": false,
            "isButtonActivated": false,
            "isButton2Activated": false,
            "isButton1Activated": false,
            "selectedSlideLabel": "",
            "selectedSlideValue": "",
        };
        this.getSelectedSlide = this.getSelectedSlide.bind(this);
    }

    getSelectedSlide() {

        const label = document.querySelector('.slide-visible img').getAttribute('data-label');
        const value = document.querySelector('.slide-visible img').getAttribute('code-jante');
        this.setState({"selectedSlideLabel": label});
        this.setState({"selectedSlideValue": value});
        this.setState({isButtonActivated: true, isButton2Activated: false})

        this.props.data.rims = value;

        if (value) {
            const calculConso = this.props.onDataChange("rims");
            calculConso();
        }
    }

    render() {
        const {data, choices, onDataChange} = this.props;
        let loadingRims = false;
        let date = data.date ? data.date : "apres";
        let IE = /*@cc_on!@*/false || !!document.documentMode;
        const client = ("undefined" !== typeof Configuration.brand && Configuration.brand === "P" ? "ap":"");
        if (date==="apres"){
            var temp=[];
            choices.models=choices.models.filter((x, i)=> {
                if (temp.indexOf(x.label) < 0) {
                    temp.push(x.label);
                    return true;
                }
                return false;
            });
        }
        if(date === 'avant'){
            return (
                <React.Fragment>
                    <ChoiceRow
                        label={`${t('Step1_form_date')}*`}
                        value={data.date}
                        data={choices.dates}
                        onChange={onDataChange("date")}
                    />
                    <ChoiceRow
                        label={`${t('Step1_form_model')}*`}
                        value={data.model}
                        data={choices.models}
                        onChange={onDataChange("model")}
                    />
                    <ChoiceRow
                        label={`${t('Step1_form_bodystyle')}*`}
                        value={data.bodyStyle}
                        data={choices.body_styles}
                        onChange={onDataChange("bodyStyle")}
                    />
                    <ChoiceRow
                        label={`${t('Step1_form_trim')}*`}
                        value={data.commercialName}
                        data={choices.commercial_names}
                        onChange={onDataChange("commercialName")}
                    />
                    <ChoiceRow
                        label={`${t('Step1_form_engine')}*`}
                        value={data.engine}
                        data={choices.engines}
                        onChange={onDataChange("engine")}
                    />
                    <ChoiceRow
                        label={`${t('Step1_form_gearbox')}*`}
                        value={data.transmission}
                        data={choices.transmissions}
                        onChange={onDataChange("transmission")}
                    />
                    <ChoiceRow
                        label={`${t('Step1_form_rims')}*`}
                        classLabel={client}
                        value={data.rims}
                        data={choices.rims}
                        loading={loadingRims}
                        onChange={onDataChange("rims")}
                    />
                </React.Fragment>
            );
        }else if(IE && (date === "apres")){
            return (
                <React.Fragment>
                    <ChoiceRow
                        label={`${t('Step1_form_date')}*`}
                        value={data.date}
                        data={choices.dates}
                        onChange={onDataChange("date")}
                    />
                    <ChoiceRow
                        label={`${t('Step1_form_model')}*`}
                        value={data.model}
                        data={choices.models}
                        onChange={onDataChange("model")}
                    />
                    <ChoiceRow
                        label={`${t('Step1_form_bodystyle')}*`}
                        value={data.bodyStyle}
                        data={choices.body_styles}
                        onChange={onDataChange("bodyStyle")}
                    />
                    <ChoiceRow
                        label={`${t('Step1_form_trim')}*`}
                        value={data.commercialName}
                        data={choices.commercial_names}
                        onChange={onDataChange("commercialName")}
                    />
                    <ChoiceRow
                        label={`${t('Step1_form_engine')}*`}
                        value={data.engine}
                        data={choices.engines}
                        onChange={onDataChange("engine")}
                    />
                    <ChoiceRow
                        label={`${t('Step1_form_gearbox')}*`}
                        value={data.transmission}
                        data={choices.transmissions}
                        onChange={onDataChange("transmission")}
                    />
                    <ChoiceRow
                        className={"rimsClass"}
                        label={`${t('Step1_form_rims')}*`}
                        classLabel={client}
                        value={data.rims}
                        data={choices.rims}
                        loading={loadingRims}
                        onChange={onDataChange("rims")}
                    />
                </React.Fragment>
            );
        }else{
            return (
                <React.Fragment>
                    <ChoiceRow
                        label={`${t('Step1_form_date')}*`}
                        value={data.date}
                        data={choices.dates}
                        onChange={onDataChange("date")}
                    />
                    <ChoiceRow
                        label={`${t('Step1_form_model')}*`}
                        value={data.model}
                        data={choices.models}
                        onChange={onDataChange("model")}
                    />
                    <ChoiceRow
                        label={`${t('Step1_form_bodystyle')}*`}
                        value={data.bodyStyle}
                        data={choices.body_styles}
                        onChange={onDataChange("bodyStyle")}
                    />
                    <ChoiceRow
                        label={`${t('Step1_form_trim')}*`}
                        value={data.commercialName}
                        data={choices.commercial_names}
                        onChange={onDataChange("commercialName")}
                    />
                    <ChoiceRow
                        label={`${t('Step1_form_engine')}*`}
                        value={data.engine}
                        data={choices.engines}
                        onChange={onDataChange("engine")}
                    />
                    <ChoiceRow
                        label={`${t('Step1_form_gearbox')}*`}
                        value={data.transmission}
                        data={choices.transmissions}
                        onChange={onDataChange("transmission")}
                    />
                    {
                        !IE && (choices.rims.length === 0) ? (loadingRims = true, this.setState({isCarosselActivated: false}), this.setState({isButtonActivated: false})) : (loadingRims = false)
                    }
                    {!IE && (!this.state.isCarosselActivated || choices.rims.length === 0) &&
                    <LabelButton classLabel={client} disabled={loadingRims} data={choices.rims}
                                 onClick={() => this.setState({isCarosselActivated: true})}/>}
                    {!IE && ((this.state.isCarosselActivated && !this.state.isButtonActivated && choices.rims.length !== 0) || this.state.isButton2Activated) &&
                    <Carrousel classLabel={client} onClick={() => this.getSelectedSlide()} data={choices}
                               value={data.rims = (this.state.selectedSlideValue, this.state.selectedSlideLabel)}/>}
                    {!IE && ((!this.state.isButton2Activated && this.state.isButtonActivated && choices.rims.length !== 0)) &&
                    <LabelButtonLabel classLabel={client} onClick={() => {
                        this.setState({"isButton2Activated": true})
                    }} label={this.state.selectedSlideLabel}/>}
                </React.Fragment>
            );
        }
    }
}

Step1Choices.propTypes = {
    className: PropTypes.string,
    choices: PropTypes.object.isRequired,
    loadingRims: PropTypes.bool,
    onDataChange: PropTypes.func.isRequired
};

Step1Choices.defaultProps = {
    loadingRims: true
};

export default Step1Choices;


// WEBPACK FOOTER //
// ./src/components/widgets/Step1Choices.js